<template>
	<div
		class="g-block-title-center-divider g-block-title-padding"
		:class="{
			'g-block-title-center-divider--edit': editable,
			'is-active': editable && active,
			'g-block-title-center-divider--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-center-divider__content">
			<div class="g-block-title-center-divider__part g-block-title-center-divider__part--primary" :style="{ color: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-center-divider__text g-block-title-center-divider__text--primary"
					fit-content
					:model-value="data.primaryText"
					placeholder="主标题"
					@update:model-value="onPrimaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-center-divider__text g-block-title-center-divider__text--primary"
					v-html="data.primaryText || ''"
				></div>
			</div>
			<span class="g-block-title-center-divider__line" :style="{ background: themeColor }"></span>
			<div class="g-block-title-center-divider__part g-block-title-center-divider__part--secondary" :style="{ color: lightColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-center-divider__text g-block-title-center-divider__text--secondary"
					fit-content
					:model-value="data.secondaryText"
					placeholder="副标题"
					@update:model-value="onSecondaryUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-center-divider__text g-block-title-center-divider__text--secondary"
					v-html="data.secondaryText || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { dualTitleMixin } from '../shared/dualTitleMixin.js';

	export default {
		name: 'GBlockTitleCenterDivider',
		components: { RichTextEditable },
		mixins: [dualTitleMixin],
	};
</script>

<style scoped lang="less">
	.g-block-title-center-divider {
		text-align: center;

		&--edit {
			border: 1px solid transparent;
			border-radius: 4px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-title-center-divider__content {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 12px;
	}

	.g-block-title-center-divider__line {
		display: block;
		width: 32px;
		height: 2px;
		border-radius: 1px;
		flex-shrink: 0;
	}

	.g-block-title-center-divider__part {
		width: 100%;
		display: flex;
		justify-content: center;
	}

	.g-block-title-center-divider__text {
		display: inline-flex;
		justify-content: center;
		line-height: 1.35;
		padding: 0;
		font-family: inherit;
		word-break: break-word;
		white-space: pre-wrap;
		color: inherit;
		text-align: center;

		&--primary {
			font-size: 20px;
			font-weight: 700;
		}

		&--secondary {
			font-size: 14px;
			font-weight: 400;
		}

		:deep(.g-rich-text-editable) {
			display: inline-flex;
			justify-content: center;
			width: auto;
			max-width: 100%;
			color: inherit;
		}

		:deep(.g-rich-text-editable__content) {
			line-height: 1.35;
			min-height: unset;
			padding: 0;
			color: inherit;
			text-align: center;
		}

		:deep(span),
		:deep(font),
		:deep(p),
		:deep(div) {
			margin: 0;
			padding: 0;
			color: inherit;
		}
	}

	.g-block-title-center-divider--h5 {
		.g-block-title-center-divider__content {
			gap: 0.24rem;
		}

		.g-block-title-center-divider__line {
			width: 0.64rem;
			height: 0.04rem;
		}

		.g-block-title-center-divider__text--primary {
			font-size: 0.4rem;
		}

		.g-block-title-center-divider__text--secondary {
			font-size: 0.28rem;
		}
	}
</style>
